var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOeeCpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3324 13.7133V5.54712C18.3321 5.46211 18.3252 5.37725 18.3117 5.2934L14.998 7.25191V16.5244L17.6205 14.9741L17.6206 14.9742C17.8404 14.8505 18.023 14.6677 18.1485 14.4454C18.274 14.2231 18.3376 13.9698 18.3324 13.7132L18.3324 13.7133ZM5.5901 6.44959L13.4357 1.81335L10.7108 0.203291C10.4962 0.0703305 10.2502 0 9.99944 0C9.74871 0 9.50264 0.0703305 9.28812 0.203291L2.37811 4.28637C2.30613 4.32866 2.23769 4.37705 2.17338 4.43081L5.58989 6.45022L5.5901 6.44959ZM9.9994 9.05505L6.56316 7.02459L14.4087 2.38835L17.6219 4.2863C17.6936 4.32873 17.7621 4.37712 17.8262 4.43074L9.9994 9.05505ZM9.51282 19.1664C9.43501 19.1363 9.35991 19.0998 9.28806 19.0573L2.37806 14.9742C2.15827 14.8505 1.97569 14.6677 1.85018 14.4454C1.72467 14.2231 1.66106 13.9698 1.66632 13.7131V5.54699C1.6666 5.46198 1.67356 5.37726 1.68705 5.29341L9.51264 9.91776L9.51282 19.1664ZM4.6419 13.3245C4.4092 13.187 4.1116 13.2686 3.97729 13.5067C3.84284 13.7449 3.92263 14.0495 4.15534 14.1869L6.75047 15.7207C6.86235 15.7917 6.9978 15.8134 7.12557 15.7806C7.25336 15.7479 7.36268 15.6633 7.42856 15.5466C7.49444 15.4298 7.51134 15.2906 7.47513 15.1609C7.43907 15.0313 7.35302 14.9221 7.23688 14.8584L4.6419 13.3245ZM14.0243 17.0996V7.82745L10.4858 9.91835V19.1667C10.5634 19.1367 10.6387 19.1004 10.7105 19.058L14.0243 17.0996Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOeeCpt);
export default __webpack_public_path__ + "static/media/oee-cpt.6f3ad9b5f0296a125f4206557ce7a588.svg";
export { ForwardRef as ReactComponent };